import { Col, Row } from "antd";
import classNames from "classnames";
import { SuiFrensFlow } from 'utils/helper';
import AddressFormComponent from "components/AddressFormComponent";
import ECSShippingComponent from '../ECSShippingComponent';
import { FormTypeBilling, FormTypeShipping } from 'components/Ecommerce/ECTheme/ECAddressComponent/constant';
import { useStyles } from './style';

const ECSBillingComponent = ({
    setShowShippingLayout,
    form,
    isBothSame,
    onChange,
    formData,
    setFormData,
    errors,
    setErrors,
    nextForm,
    nextFormData,
    setNextFormData,
    itemList,
    grandTotal,
    onCheckout,
    onBtnLoader,
}: any) => {
    const classes = useStyles();
    return (
        <>
            <div className={classNames(classes.billingSection)}>
                <div className='billingDetailsSection'>
                    <Row gutter={{ xs: 20, sm: 20, md: 20, lg: 20 }}>
                        <Col
                            className="gutter-row"
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 12 }}
                            lg={{ span: 16 }}>
                            <div className="billingForm">
                                <p className="sLgText textCapitalize">Shipping Details</p>
                                <AddressFormComponent
                                    formData={form}
                                    formType={FormTypeShipping}
                                    isBothSame={isBothSame}
                                    onChange={onChange}
                                    initialValues={formData}
                                    setInitialValues={setFormData}
                                    errors={errors}
                                    setErrors={setErrors}
                                    flowName={SuiFrensFlow}
                                />
                                {!isBothSame && (
                                    <>
                                        <p className="sLgText textCapitalize">Billing Details</p>
                                        <AddressFormComponent
                                            formData={nextForm}
                                            formType={FormTypeBilling}
                                            isBothSame={isBothSame}
                                            onChange={onChange}
                                            initialValues={nextFormData}
                                            setInitialValues={setNextFormData}
                                            errors={errors}
                                            setErrors={setErrors}
                                            flowName={SuiFrensFlow}
                                        />
                                    </>
                                )}
                            </div>
                        </Col>
                        <Col
                            className="gutter-row"
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 12 }}
                            lg={{ span: 8 }}>
                            <ECSShippingComponent
                                itemList={itemList}
                                grandTotal={grandTotal}
                                onCheckout={onCheckout}
                                onBtnLoader={onBtnLoader}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default ECSBillingComponent;